<mat-card class="mat-elevation-z8 container-card">

    <mat-card-content class="mat-elevation-z8">
        <mat-tab-group (selectedTabChange)="onTabChanged($event)">

            <mat-tab label="Carica JSON o XML">
                <!-- Input nascosto ma accessibile -->
                <input #fileInput id="fileInput" type="file" class="sr-only" accept=".xml,.json" (change)="onFileSelected($event)" />
                <div class="m-3">
                    <!-- Drop-zone cliccabile e focusable -->
                    <button type="button" class="drop-zone" [disabled]="!canDoActions('BACKOFFICE_ADMIN')" [class.dragover]="isHovering" [attr.aria-label]="'Carica un documento JSON o XML. Trascina un file qui oppure premi Invio o Barra spaziatrice per selezionarlo.'" (click)="openFileDialog()"
                        (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
            <div class="dz-content">
                <mat-icon class="dz-icon" aria-hidden="true">cloud_upload</mat-icon>
              <div class="dz-title">Carica Un Documento</div>
              <div class="dz-subtitle">
                Trascina un Documento <strong>JSON</strong> o <strong>XML</strong> nell’area evidenziata
                oppure <span class="dz-action">clicca qui</span>.
              </div>
              <div *ngIf="fileName" class="dz-filename" aria-live="polite">
                File caricato: {{ fileName }}
              </div>
            </div>
          </button>
                </div>
                <mat-progress-bar *ngIf="isUploading" mode="indeterminate"></mat-progress-bar>
            </mat-tab>

            <mat-tab label="Monitoring JSON">
                <div class="filters">
                    <app-date-range-filter #filter (filterChange)="onDateFilterChange($event)" class="ms-3"></app-date-range-filter>
                    <app-search-bar #filter [filterFields]="filterFields" [filterMap]="filterMap" [filterLabels]="filterLabels" (filtersChanged)="onFilterChanged($event)">
                    </app-search-bar>
                </div>

                <app-shared-table [nameTable]="'JSON-XML-logs'" [dataSource]="dataSourceLogs" [displayedColumns]="['name', 'updatedDate', 'dimension', 'actions']" [notAllowAdd]="true" [notAllowEdit]="true" [notAllowDelete]="true" [columnLabels]="{name: 'Nome', updatedDate: 'Caricato il', dimension: 'Dimensione'}" [length]="totalItems" [pageSize]="pageSize" [pageIndex]="pageIndex"
                    (pageChanged)="onPageChanged($event)" (downloadAction)="downloadFile($event)" (sortChanged)="onSortChanged($event)" [isLoading]="isLoading">
                </app-shared-table>
            </mat-tab>

            <mat-tab label="Monitoring XML">
                <div class="filters">
                    <app-date-range-filter #filter (filterChange)="onDateFilterChange($event)" class="ms-3"></app-date-range-filter>
                    <app-search-bar #filter [filterFields]="filterFields" [filterMap]="filterMap" [filterLabels]="filterLabels" (filtersChanged)="onFilterChanged($event)">
                    </app-search-bar>
                </div>

                <app-shared-table [nameTable]="'JSON-XML-logs'" [dataSource]="dataSourceLogs" [displayedColumns]="['name', 'updatedDate', 'dimension', 'actions']" [notAllowAdd]="true" [notAllowEdit]="true" [notAllowDelete]="true" [columnLabels]="{name: 'Nome', updatedDate: 'Caricato il', dimension: 'Dimensione'}" [length]="totalItems" [pageSize]="pageSize" [pageIndex]="pageIndex"
                    (pageChanged)="onPageChanged($event)" (downloadAction)="downloadFile($event)" (sortChanged)="onSortChanged($event)" [isLoading]="isLoading">
                </app-shared-table>
            </mat-tab>
            @if(currentTenant === 'SIAG'){
                <mat-tab label="Monitoring Kontent.ai">
                    <div class="filters">
                        <app-date-range-filter #filter (filterChange)="onDateFilterChange($event)" class="ms-3"></app-date-range-filter>
                        <app-search-bar #filter [filterFields]="filterFieldsKentico" [filterMap]="filterMapKentico" [filterLabels]="filterLabelsKentico" (filtersChanged)="onFilterChangedKentico($event)">
                        </app-search-bar>
                    </div>

                    <app-shared-table [nameTable]="'Kentico-logs'" [dataSource]="dataSourceKenticoLogs" [displayedColumns]="['projectId','documentId','status','date','message','operation']" [columnLabels]="{projectId: 'ID Progetto', documentId: 'ID Documento', status: 'Status', date: 'Data ricezione', message: 'Messaggio', operation: 'Operazione'}" [length]="totalItems" [pageSize]="pageSize" [pageIndex]="pageIndex"
                        (pageChanged)="onPageChangedKentico($event)"  (sortChanged)="onSortChangedKentico($event)"[isLoading]="isLoading">
                    </app-shared-table>
                </mat-tab>
            }
            

        </mat-tab-group>
    </mat-card-content>
</mat-card>